
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.281","height":"20.291"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1598.056 -388.997)","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"stroke":"#354052"}},[_c('g',{attrs:{"opacity":".5"}},[_c('path',{attrs:{"d":"M1598.678 392.997h14.824M1598.678 395.997h14.824M1598.678 398.997h14.824M1598.678 401.997h14.824M1598.678 404.997h14.824"}})]),_c('g',{attrs:{"transform":"translate(1609.167 396.496)"}},[_c('path',{attrs:{"d":"M8.787-.003H.001V1.63M3.317 12.292h5.136v-.955"}}),_c('line',{attrs:{"y2":"11","transform":"translate(5.339 .726)"}}),_c('path',{attrs:{"d":"M7.178-.003h3.49v1.634M4.257 12.292h-2.04v-.956"}})])]),_c('path',{attrs:{"d":"M1598.677 392.997h14.824M1598.677 395.997h14.824M1598.677 398.997h14.824M1598.677 401.997h14.824M1598.677 404.997h14.824","stroke":"#c1c5cb"}}),_c('path',{attrs:{"d":"M1617.954 396.493h-8.786v1.633M1612.485 408.788h5.136v-.955","stroke":"#354052"}}),_c('line',{attrs:{"y2":"11","transform":"translate(1614.508 397.222)","stroke":"#354052"}}),_c('path',{attrs:{"d":"M1616.347 396.493h3.49v1.634M1613.426 408.788h-2.04v-.956","stroke":"#354052"}}),_c('g',{attrs:{"transform":"rotate(180 1057.023 340.663)","stroke":"#354052"}},[_c('line',{attrs:{"y2":"6.244","transform":"translate(512.447 284.537)"}}),_c('g',{attrs:{"transform":"translate(509.611 288.708)"}},[_c('path',{attrs:{"d":"M5.671.001L2.834 2.914"}}),_c('line',{attrs:{"x2":"2.835","y2":"2.913"}})])])])])
          )
        }
      }
    